export const formatPhoneNumber = (text: string) => {
  return text && text.length === 10
    ? `(${text.substr(0, 3)}) ${text.substr(3, 3)}-${text.substr(
        6,
        text.length
      )}`
    : text;
};

export const formatTwilioPhoneNumber = (text: string) => {
  if (!text) return text;

  // Remove +1 country code if present
  const cleaned = text.startsWith('+1') ? text.substring(2) : text;

  if (cleaned.length === 10) {
    return `(${cleaned.substr(0, 3)}) ${cleaned.substr(3, 3)}-${cleaned.substr(6)}`;
  }

  return text;
};

export const formatPhoneNumberInput = (text: string) => {
  // Remove all non-digit characters
  const digits = text.replace(/\D/g, '');

  if (digits.length === 0) return '';
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.substr(0, 3)}) ${digits.substr(3)}`;
  return `(${digits.substr(0, 3)}) ${digits.substr(3, 3)}-${digits.substr(6, 4)}`;
};

export const extractDigits = (text: string) => {
  return text.replace(/\D/g, '');
};
